import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError, Observable, of } from 'rxjs';
import { ToastService } from '../../clientapp/src/services/toast.service';
import { LoggerService } from './logger.service';

@Injectable({ providedIn: 'root' })
export class ErrorService {
  toastService = inject(ToastService);
  loggerService = inject(LoggerService);

  handleError(error: HttpErrorResponse) {
    let errorMessage = 'An unknown error occurred';
    console.error(error);

    if (error.status === 400 || (error.status === 500 && error.error?.errors)) {
      // Extract errors from the response body
      const validationErrors = error.error?.errors;

      if (Array.isArray(validationErrors) && validationErrors.length > 0 && validationErrors[0]?.errorMessage) {
        errorMessage = validationErrors.map((e) => e.errorMessage).join(' ');
      } else if (Array.isArray(validationErrors)) {
        errorMessage = validationErrors.join(' ');
      }
    } else if (error.error?.message) {
      errorMessage = error.error.message;
    } else if (error.error?.detail) {
      errorMessage = error.error.detail;
    }

    // Show Ionic Toast Notification
    this.toastService.error(errorMessage);

    this.loggerService.logException(error, 'Error Service', { errorMessage });
  }
}
